import { createPortal } from "react-dom";
import Div from "../Div"; 
import FormButton from "../FormButton";
import { useEffect, useState, useCallback } from "react";
import { getMeetingDataHttp } from "../../http/renewalHttp/RenewalHttp";

export default function ViewMeetingDataModal({ customer_data, handleClicked }) {
    const [meetings, setMeetings] = useState([]);
    const [loading, setLoading] = useState(true);

    const openEmailModal = () => {
        if (meetings.length === 0) {
            alert("No data available to send.");
            return;
        }

        const subject = `MOM of Meetings - ${customer_data.customerDomain}`;
        
        // 1. Create a professional text-based table
        let tableText = "Meeting History Detail:\n";
        tableText += "--------------------------------------------------------------------------------------------\n";
        tableText += "| Date       | Type    | Product                      | Count | Adoption | Rating | Feedback\n";
        tableText += "--------------------------------------------------------------------------------------------\n";

        meetings.forEach(m => {
            const date = m.timestamp.split('T')[0];
            const type = (m.meeting_type || "").padEnd(7);
            const prod = (m.new_opps_product || "").padEnd(28);
            const count = (m.new_opps_count || "0").toString().padEnd(5);
            const adopt = (m.adoption || "").padEnd(8);
            const rate = (m.support_rating || "").padEnd(6);
            const feedback = m.feedback || "N/A";

            tableText += `| ${date} | ${type} | ${prod} | ${count} | ${adopt} | ${rate} | ${feedback}\n`;
        });
        
        tableText += "--------------------------------------------------------------------------------------------\n";

        const body = `Dear Team,

Please find the Meeting History for ${customer_data.customerDomain} below:

${tableText}

Best regards,
Siddhi`;

        const encodedSubject = encodeURIComponent(subject);
        const encodedBody = encodeURIComponent(body);

        // Gmail Direct Link for desktop browsers
        const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=siddhi.dorage@shivaami.com&su=${encodedSubject}&body=${encodedBody}`;
        const mailtoLink = `mailto:siddhi.dorage@shivaami.com?subject=${encodedSubject}&body=${encodedBody}`;

        if (navigator.userAgent.includes("Chrome") || navigator.userAgent.includes("Firefox")) {
            window.open(gmailLink, "_blank");
        } else {
            window.location.href = mailtoLink;
        }
    };

    const fetchMeetings = useCallback(async () => {
        const response = await getMeetingDataHttp(customer_data.customerDomain);
        if (response && response.meetings) {
            setMeetings(response.meetings);
        }
        setLoading(false);
    }, [customer_data.customerDomain]);

    useEffect(() => {
        fetchMeetings();
    }, [fetchMeetings]);

    return createPortal(
        <Div className="modal-backdrop" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <dialog open style={{ zIndex: '1001', margin: 'auto', padding: '20px', width: '850px', maxWidth: '95%', borderRadius: '8px', border: 'none' }}>
                <Div className="modal-content" style={{ border: 'none' }}>
                    
                    {/* UPDATED HEADER AREA */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 style={{ margin: 0 }}>Meeting History: {customer_data.customerDomain}</h5>
                        <button 
                            className="btn btn-outline-primary btn-sm" 
                            style={{ width: 'auto', padding: '5px 20px' }} // Normal size button
                            onClick={openEmailModal}
                        >
                           <strong>Email MOM</strong> 
                        </button>
                    </div>

                    <hr />
                    
                    {loading ? <p>Loading history...</p> : (
                        meetings.length > 0 ? (
                            <div className="table-responsive" style={{ maxHeight: '450px', overflowY: 'auto' }}>
                                <table className="table table-bordered table-striped table-sm">
                                    <thead className="thead-light" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                        <tr>
                                            <th>Date</th>
                                            <th>Type</th>
                                            <th>Product</th>
                                            <th>Total Count</th>
                                            <th>Adoption</th>
                                            <th>Rating</th>
                                            <th>Feedback</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {meetings.map((m, i) => (
                                            <tr key={i}>
                                                <td>{m.timestamp.split('T')[0]}</td>
                                                <td>{m.meeting_type}</td>
                                                <td>{m.new_opps_product}</td>
                                                <td>{m.new_opps_count}</td>
                                                <td>{m.adoption}</td>
                                                <td>{m.support_rating}</td>
                                                <td>{m.feedback}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : <p className="text-center text-muted py-4">No meeting records found for this domain.</p>
                    )}

                    <Div className="d-flex justify-content-end mt-4 pt-3" style={{ borderTop: '1px solid #eee' }}>
                        <FormButton className="btn btn-secondary btn-sm" onClick={() => handleClicked(false)}>Close Window</FormButton>
                    </Div>
                </Div>
            </dialog>
        </Div>,
        document.getElementById('modal')
    );
}